// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2uI9E","title":"AfterFrontImage_title__23yMi"};